module.exports = __webpack_public_path__ + "static/media/RyanW.066628c3.jpg";